import { ParagonIntegrations } from "components/molecules/ParagonIntegration";

const IntegrationsModule = () => {
  return (
    <>
      <ParagonIntegrations />
    </>
  );
};
export default IntegrationsModule;
